import { ConditionOption } from '../../../domain/models/listing.model';

export const listingConditionOptions = [
  {
    label: 'Ново',
    value: ConditionOption.NEW,
  },
  {
    label: 'Употребявано',
    value: ConditionOption.USED,
  },
  {
    label: 'Повредено',
    value: ConditionOption.DAMAGED,
  },
];
